import React, {useRef, useState} from 'react';
import Title from "../../../customer/ProductsCustomer/Title";
import CheckoutCustomerCotizar from "./Checkout/CheckoutCustomerCotizar";

import Header from "../../../customer/ProductsCustomer/Header";
import Footer from "../../../customer/ProductsCustomer/Footer";
import useStyles from './Checkout/styles'
import {useMediaQuery} from "react-responsive";
import HeaderMobile from "../../../customer/ProductsCustomer/Mobile/HeaderMobile";
import TitleMobile from "../../../customer/ProductsCustomer/Mobile/TitleMobile";

function CustomerCotizarPage(props) {

    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });
    const topFormRef = useRef()
    const handleScrollIntoView = () => {
        topFormRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    const classes = useStyles();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    backgroundColor: "#F5F6F9",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                    }}
                >
                    {isMobileDevice ? <HeaderMobile/> : <Header/>}
                </div>

                <div
                    ref={topFormRef}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginBottom: "50px"
                    }}
                >
                    {isMobileDevice
                        ? <TitleMobile title={"SEGUROS"}
                                       subtitle={"Solicite una cotización completando la siguiente información:"}/>
                        : <Title title={"SEGUROS"}
                                 subtitle={"Solicite una cotización completando la siguiente información:"}/>}
                </div>

                <div style={{width:"100%",  display: "flex",
                    flexDirection: "row", justifyContent:"center"}}>
                    {isMobileDevice
                        ? <div className={classes.formBoxMobile}>
                            <CheckoutCustomerCotizar
                                scrollIntoView={handleScrollIntoView}
                                isMobile={true}
                                confirmationModalOpen={confirmationModalOpen}
                                setConfirmationModalOpen={setConfirmationModalOpen}/>
                        </div>
                        :
                        <div className={classes.formBox}>
                            <CheckoutCustomerCotizar
                                scrollIntoView={handleScrollIntoView}
                                isMobile={false}
                                confirmationModalOpen={confirmationModalOpen}
                                setConfirmationModalOpen={setConfirmationModalOpen}/>
                        </div>
                    }
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "80px",
                        marginBottom: "50px",
                        width: "100%"
                    }}
                >
                    <Footer/>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CustomerCotizarPage;